/** Canonical DataObserve Catalog API paths (backend/do-app-fe). Relative — see axiosClient. */

// --- Auth (/v1/auth) ---------------------------------------------------
export const AUTH_LOGIN = '/v1/auth/login'
export const AUTH_REGISTER = '/v1/auth/register'
export const AUTH_GOOGLE = '/v1/auth/google'
export const AUTH_REFRESH = '/v1/auth/refresh'
export const AUTH_LOGOUT = '/v1/auth/logout'
export const AUTH_ME = '/v1/auth/me'
export const AUTH_ENTITLEMENTS = '/v1/auth/entitlements'
export const AUTH_PRODUCT_SESSION = '/v1/auth/product-session'
export const AUTH_PRODUCT_SESSION_EXCHANGE = '/v1/auth/product-session/exchange'
export const AUTH_PASSWORD_FORGOT = '/v1/auth/password/forgot'
export const AUTH_PASSWORD_RESET = '/v1/auth/password/reset'
export const AUTH_PASSWORD_CHANGE = '/v1/auth/password/change'
export const AUTH_EMAIL_VERIFY = '/v1/auth/email/verify'
export const AUTH_EMAIL_RESEND = '/v1/auth/email/resend-verification'
export const INVITATIONS_ACCEPT = '/v1/invitations/accept'
export const INVITATIONS_ACCEPT_GOOGLE = '/v1/invitations/accept-google'

// --- Tenant (/v1/tenant) ------------------------------------------------
export const TENANT = '/v1/tenant'
export const TENANT_USERS = '/v1/tenant/users'
export const TENANT_INVITATIONS = '/v1/tenant/invitations'
export const TENANT_SUBSCRIPTIONS = '/v1/tenant/subscriptions'
export const TENANT_AUDIT = '/v1/tenant/audit'
export const TENANT_USAGE = '/v1/tenant/usage'
export const TENANT_DASHBOARD = '/v1/tenant/dashboard'
export const ME_USAGE = '/v1/me/usage'

// --- Products / entitlements / API keys / licenses ----------------------
export const PRODUCTS = '/v1/products'
export const ENTITLEMENTS_CHECK = '/v1/entitlements/check'
export const API_KEYS = '/v1/api-keys'
export const LICENSES_SEATS = '/v1/licenses/seats'
export const LICENSES_ASSIGNMENTS = '/v1/licenses/assignments'
export const LICENSES_ASSIGN = '/v1/licenses/assign'
export const LICENSES_REVOKE = '/v1/licenses/revoke'
export const TENANT_WS = '/v1/ws/tenant'

// --- Billing -------------------------------------------------------------
export const BILLING_CHECKOUT_SESSION = '/v1/billing/checkout-session'
export const BILLING_ADD_SEATS = '/v1/billing/add-seats'
export const BILLING_SUBSCRIBE_FREE = '/v1/billing/subscribe-free'
export const BILLING_PORTAL_SESSION = '/v1/billing/portal-session'
export const BILLING_SUBSCRIPTION_STATUS = '/v1/billing/subscription-status'
export const BILLING_INVOICES = '/v1/billing/invoices'

// --- Super-admin (/supe) --------------------------------------------------
export const SUPE_TENANTS = '/supe/tenants'
export const SUPE_SUBSCRIPTIONS = '/supe/subscriptions'
export const SUPE_PRODUCTS = '/supe/products'
export const SUPE_PLANS = '/supe/plans'
export const SUPE_USAGE_SUMMARY = '/supe/usage/summary'
export const SUPE_AUDIT = '/supe/audit'
export const SUPE_STATS = '/supe/stats'
export const SUPE_IMPERSONATE = '/supe/impersonate'

// --- Meeting notes (unrelated legacy service) -----------------------------
export const MEETING_NOTES = '/api/meeting-notes'
export const MEETING_NOTES_QUERY = '/api/meeting-notes/query'
export const MEETING_NOTES_TRANSCRIPT = '/api/meeting-notes/transcript'
